import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { makeStyles } from "@mui/styles";
import Options from "../components/Options";
import ModalAbout from "../components/ModalAbout";
import { getTitleFromAppContent, logError } from "../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { trackPageView } from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import PageBackButton from "../components/PageBackButton";
import { changeTab } from "../redux/TabSlice";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const useStyles = makeStyles((theme) => ({
  bgcolor: {
    background: "#FFFFFF",
  },
  textColor: {
    color: theme.palette.primary.main,
  },

  sectionbg: {
    background: theme.palette.primary.main,
  },
  sectionBgLight: {
    backgroundColor: "#F6F1F4",
  },
  fullScreen: {
    minHeight: "100vh",
  },
  input: {
    width: "500px",
    border: "1px solid #AE4971",
    display: "block",
    margin: "15px 0",
    "&::placeholder": {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "calc(100vw - 24px)",
    },
  },
}));

const Contact = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openAbout, setOpenAbout] = useState(false);
  const { appContent } = useSelector((state) => state.appContent);
  const [submitTitle, setSubmitTitle] = useState("");
  const [nameTitle, setNameTitle] = useState("");
  const [emailTitle, setEmailTitle] = useState("");
  const [addressTitle, setAddressTitle] = useState("");
  const [messageTitle, setMessageTitle] = useState("");
  const [contactTitle, setContactTitle] = useState("");
  const [subjectTitle, setSubjectTitle] = useState("");
  const [nameText, setNameText] = useState("");
  const [emailText, setEmailText] = useState("");
  const [addressText, setAddressText] = useState("");
  const [messageText, setMessageText] = useState("");
  const [subjectText, setSubjectText] = useState("");
  const [tabSelect, setTabSelect] = useState("Contact");
  const [reportMissingTitle, setReportMissingTitle] = useState("");
  const { backFromSettings } = useSelector((state) => state.page);
  const [reportProblemTitle, setReportProblemTitle] = useState("");
  const [generalTitle, setGeneralTitle] = useState("");
  const { isEnglish, selLanguageId } = useSelector((state) => state.language);
  const { selProvinceId, selDistrictId } = useSelector((state) => ({ selProvinceId: state.province.selProvinceId, selDistrictId: state.district.selDistrictId }));
  const handleOpen = () => setOpenAbout(true);
  const handleClose = () => {
    setOpenAbout(false);
  };

  useEffect(() => {
    trackPageView("Contact", { province: selProvinceId, district: selDistrictId, language: selLanguageId });
  }, [selProvinceId, selDistrictId, selLanguageId]);

  useEffect(() => {
    if (appContent) {
      setAddressTitle(getTitleFromAppContent(appContent, "Address"));
      // CHANGED: Use "Feedback" instead of "Contact" for the form title
      setContactTitle(getTitleFromAppContent(appContent, "Feedback") || "Feedback");
      setMessageTitle(getTitleFromAppContent(appContent, "Message"));
      setNameTitle(getTitleFromAppContent(appContent, "Name"));
      setEmailTitle(getTitleFromAppContent(appContent, "Email"));
      setSubjectTitle(getTitleFromAppContent(appContent, "Subject"));
      setSubjectText(getTitleFromAppContent(appContent, "Subject"));
      setSubmitTitle(getTitleFromAppContent(appContent, "Submit"));
      setReportMissingTitle(getTitleFromAppContent(appContent, "Report Missing Services"));
      setReportProblemTitle(getTitleFromAppContent(appContent, "Report a Problem"));
      setGeneralTitle(getTitleFromAppContent(appContent, "General Enquiries"));
    }
  }, [appContent]);

  const handleSubmit = async () => {
    // Validate required fields
    if (!nameText || !emailText || !messageText) {
      toast.error("Please fill in all required fields (Name, Email, Message)");
      return;
    }

    try {
      // CHANGED: Submit to new feedback API endpoint
      await axios.post(`${process.env.REACT_APP_LOCAL_API}/feedback`, {
        name: nameText,
        email: emailText,
        address: addressText,
        subject: subjectText,
        message: messageText,
        platform: 'web'
      });
      toast.success("Thank you for your feedback!");
      // Clear form
      setNameText("");
      setEmailText("");
      setAddressText("");
      setMessageText("");
      setSubjectText(subjectTitle);
    } catch (error) {
      logError(error, "Contact/feedback");
      toast.error(error?.response?.data?.error ?? "Failed to submit feedback");
    }
  };

  useEffect(() => {
    dispatch(changeTab(tabSelect));
  }, [tabSelect, dispatch]);

  return (
    <div className={`${classes.sectionBgLight} flex flex-col`}>
      <div>
        <Header />
        <PageBackButton
          onClick={() => {
            if (backFromSettings === "Contact") setTabSelect("HumQadam");
            else setTabSelect(backFromSettings);
          }}
        />
        <Options handleOpen={handleOpen} />
        <div className="px-5 mt-2 pb-10">
          <h6
            className={`text-center mb-8 text-2xl ${classes.textColor} font-bold`}
          >
            {contactTitle}
          </h6>
          <div className="flex flex-col sm:flex-row justify-center items-center ">
            <div className={`flex flex-col items-center`}>
              <input
                type="text"
                value={nameText}
                onChange={(e) => setNameText(e.target.value)}
                placeholder={nameTitle}
                className={`bg-white px-4 py-2 ${
                  isEnglish ? "text-left" : "text-right"
                } ${classes.textColor} ${classes.input} rounded-xl`}
              />
              <input
                type="email"
                value={emailText}
                onChange={(e) => setEmailText(e.target.value)}
                placeholder={emailTitle}
                className={`bg-white px-4 py-2 ${
                  isEnglish ? "text-left" : "text-right"
                } ${classes.textColor} ${classes.input} rounded-xl`}
              />
              <input
                type="text"
                placeholder={addressTitle}
                value={addressText}
                onChange={(e) => setAddressText(e.target.value)}
                className={`bg-white px-4 py-2 ${
                  isEnglish ? "text-left" : "text-right"
                }  ${classes.textColor} ${classes.input} rounded-xl`}
              />
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={subjectText}
                  className={`bg-white ${
                    isEnglish ? "text-left" : "text-right text-sm"
                  }  ${classes.textColor} ${classes.input} rounded-xl`}
                  style={{
                    fontFamily: "Roboto,jameel-noori",
                    color: "#A94E76",
                  }}
                  onChange={(e) => {
                    setSubjectText(e.target.value);
                  }}
                >
                  <MenuItem
                    style={{
                      fontFamily: "Roboto,jameel-noori",
                      color: "#A94E76",
                    }}
                    value={subjectTitle}
                  >
                    {subjectTitle}
                  </MenuItem>
                  <MenuItem
                    style={{
                      fontFamily: "Roboto,jameel-noori",
                      color: "#A94E76",
                    }}
                    value={reportMissingTitle}
                  >
                    {reportMissingTitle}
                  </MenuItem>
                  <MenuItem
                    style={{
                      fontFamily: "Roboto,jameel-noori",
                      color: "#A94E76",
                    }}
                    value={reportProblemTitle}
                  >
                    {reportProblemTitle}
                  </MenuItem>
                  <MenuItem
                    style={{
                      fontFamily: "Roboto,jameel-noori",
                      color: "#A94E76",
                    }}
                    value={generalTitle}
                  >
                    {generalTitle}
                  </MenuItem>
                </Select>
              </FormControl>
              <textarea
                type="text"
                placeholder={messageTitle}
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                className={`bg-white h-32 px-4 py-2 ${
                  isEnglish ? "text-left" : "text-right"
                }  ${classes.textColor} ${classes.input} rounded-xl`}
              />
              <input
                value={submitTitle}
                onClick={handleSubmit}
                type="submit"
                className={`${classes.sectionbg} px-8 py-2 text-white rounded-xl`}
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <ModalAbout open={openAbout} handleClose={handleClose} />
      </div>
    </div>
  );
};

export default Contact;
